import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category/dianying?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
    }
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:opacity-80 transition-opacity whitespace-nowrap"
          >
            <span className="text-2xl font-heading font-bold tracking-tight">
              屁屁影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname.startsWith(`/category/${cat.slug}`)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索影片..."
                className="w-48 pl-9 pr-4 py-2 text-sm rounded-full border border-background-200 bg-background-50 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all"
              />
              <button type="submit" className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 cursor-pointer">
                <i className="ri-search-line"></i>
              </button>
            </form>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 pb-4 pt-2">
            <form onSubmit={handleSearch} className="relative mb-3 px-2">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索影片..."
                className="w-full pl-9 pr-4 py-2.5 text-sm rounded-full border border-background-200 bg-background-50 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
              <button type="submit" className="absolute left-5 top-1/2 -translate-y-1/2 text-foreground-400 cursor-pointer">
                <i className="ri-search-line"></i>
              </button>
            </form>
            <div className="flex flex-col gap-1 px-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname.startsWith(`/category/${cat.slug}`)
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {cat.label}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/about') ? 'bg-secondary-500 text-background-50' : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}